var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuspendedEv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 27,
    rx: 8,
    fill: "currentColor",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3125 10.5001C21.3125 10.8076 21.0575 11.0626 20.75 11.0626H7.25C6.9425 11.0626 6.6875 10.8076 6.6875 10.5001C6.6875 10.1926 6.9425 9.93756 7.25 9.93756H8.015L8.3 8.58006C8.57 7.26756 9.1325 6.06006 11.3675 6.06006H16.6325C18.8675 6.06006 19.43 7.26756 19.7 8.58006L19.985 9.93756H20.75C21.0575 9.93756 21.3125 10.1926 21.3125 10.5001Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6349 14.745C21.5224 13.5075 21.1924 12.1875 18.7849 12.1875H9.21494C6.80744 12.1875 6.48494 13.5075 6.36494 14.745L5.94494 19.3125C5.89244 19.8825 6.07994 20.4525 6.46994 20.88C6.86744 21.315 7.42994 21.5625 8.02994 21.5625H9.43994C10.6549 21.5625 10.8874 20.865 11.0374 20.4075L11.1874 19.9575C11.3599 19.44 11.4049 19.3125 12.0799 19.3125H15.9199C16.5949 19.3125 16.6174 19.3875 16.8124 19.9575L16.9624 20.4075C17.1124 20.865 17.3449 21.5625 18.5599 21.5625H19.9699C20.5624 21.5625 21.1324 21.315 21.5299 20.88C21.9199 20.4525 22.1074 19.8825 22.0549 19.3125L21.6349 14.745ZM11.7499 16.3125H9.49994C9.19244 16.3125 8.93744 16.0575 8.93744 15.75C8.93744 15.4425 9.19244 15.1875 9.49994 15.1875H11.7499C12.0574 15.1875 12.3124 15.4425 12.3124 15.75C12.3124 16.0575 12.0574 16.3125 11.7499 16.3125ZM18.4999 16.3125H16.2499C15.9424 16.3125 15.6874 16.0575 15.6874 15.75C15.6874 15.4425 15.9424 15.1875 16.2499 15.1875H18.4999C18.8074 15.1875 19.0624 15.4425 19.0624 15.75C19.0624 16.0575 18.8074 16.3125 18.4999 16.3125Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuspendedEv);
export default __webpack_public_path__ + "static/media/suspendedEV.e22eb1b6329814bcf38f42a671988389.svg";
export { ForwardRef as ReactComponent };